"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVMTransactionData = exports.UtxoSpending = exports.BaseSpending = exports.TransactionReceipt = exports.TransactionType = void 0;
var TransactionType;
(function (TransactionType) {
    TransactionType["Base"] = "Base transaction";
    TransactionType["Send"] = "Send transaction";
    TransactionType["Export"] = "Export transaction";
    TransactionType["Import"] = "Import transaction";
    TransactionType["Withdraw"] = "Withdraw transaction";
    TransactionType["Deposit"] = "Deposit transaction";
    TransactionType["Wrap"] = "Wrap transaction";
    TransactionType["Unwrap"] = "Unwrap transaction";
    TransactionType["PrimaryValidation"] = "Primary validation transaction";
    TransactionType["PrimaryDelegation"] = "Primary delegation transaction";
    TransactionType["CreateSupernet"] = "Create supernet transaction";
    TransactionType["ValidateSupernet"] = "Supernet validation transaction";
    TransactionType["RemoveSupernetValidator"] = "Remove supernet validator transaction";
    TransactionType["CreateChain"] = "Create chain transaction";
    TransactionType["EthCall"] = "Eth call transaction";
})(TransactionType || (exports.TransactionType = TransactionType = {}));
class TransactionReceipt {
    chainId;
    transactionType;
    transactionStatus;
    transactionId;
    constructor(chainId, transactionType, transactionStatus, transactionId) {
        this.chainId = chainId;
        this.transactionStatus = transactionStatus;
        this.transactionType = transactionType;
        this.transactionId = transactionId;
    }
}
exports.TransactionReceipt = TransactionReceipt;
class BaseSpending {
    chain;
    amount;
    assetId;
    constructor(chain, amount, assetId) {
        this.chain = chain;
        this.amount = amount;
        this.assetId = assetId;
    }
}
exports.BaseSpending = BaseSpending;
class UtxoSpending extends BaseSpending {
    utxos;
    constructor(chain, amount, assetId, utxos) {
        super(chain, amount, assetId);
        this.utxos = utxos;
    }
}
exports.UtxoSpending = UtxoSpending;
class EVMTransactionData {
    from;
    to;
    value;
    data;
    constructor(from, to, value, data) {
        this.from = from;
        this.to = to;
        this.value = value;
        this.data = data;
    }
}
exports.EVMTransactionData = EVMTransactionData;
